/* eslint-disable import/first */
import React, { useContext, useState } from 'react';
import { Link } from '@material-ui/core';
// eslint:fix grid and useTheme is removed from @material-ui/core
import { useNavigate } from '@reach/router';
import { Context } from '../Multi-lang/Wrapper';

import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */

import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
const { selectAllMain } = Slices.categorySlice;
const { selectLoginStatus } = Slices.authSlice;
const { selectCurrentCountry } = Slices.profileSlice;
import compact from 'lodash/compact';
import PizzaHutLogo from '../../brands/phd/logo';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { FaInstagram } from '@react-icons/all-files/fa/FaInstagram';
import { localizePath, getSocialMediaPath } from 'spwa-ui-library/esm/utils/helper';
import downloadGoogle from './images/googlePlay.svg';
import downloadApple from './images/appleStore.svg';
import css from './index.module.scss';

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));

const socialURLS = {
  UAE: {
    facebook: 'https://www.facebook.com/Pizzahutuae/',
    instagram: 'https://www.instagram.com/pizzahutme/',
    twitter: 'https://twitter.com/pizzahutme/',
  },
  KSA: {
    facebook: 'https://www.facebook.com/Pizzahutsaudi/',
    instagram: 'https://www.instagram.com/pizzahutsaudi/',
    twitter: 'https://twitter.com/PizzaHutSaudi/',
  },
};

const fetchSocialMediaURLs = (country) => (socialMedia) => socialURLS[country][socialMedia];

export default function PizzaHutFooter(props) {
  const country = useSelector(selectCurrentCountry);
  const isDesktop = useSelector(selectDesktop);
  const navigate = useNavigate();
  const intl = useIntl();
  const categories = useSelector(selectAllMain);
  const isLoggedIn = useSelector(selectLoginStatus);
  const result = categories?.sort((a, b) => a.position - b.position);
  const lang = intl.locale;
  const sortedCategories = compact(
    categories?.map((category, idx) => {
      if (category.isHidden === 0 && !category?.parentId && category.id !== 999) {
        const generatedPath = generateCategoryRoute({ category, locale: lang });
        return { ...category, generatedPath };
      }
    })
  );
  const exploreMenuPath = `/${intl?.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;
  const getLocalizeURL = (target) => {
    return localizePath(target, intl.locale);
  };
  const navigateTo = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };

  const profileLink = isLoggedIn ? 'profile' : 'login';

  const getSocialMedia = fetchSocialMediaURLs(country);

  return (
    <React.Fragment>
      {isDesktop && (
        <footer className={css.root}>
          <div className={css.logo}>
            <div className={css.img}>
              <PizzaHutLogo width="109" height="100" />
            </div>
          </div>
          <div className={css.menuLinks}>
            <div className={css.linkBox}>
              <h3>
                <FormattedMessage id="footer_menu" defaultMessage="Menu" />
              </h3>
              <ul>
                {sortedCategories.map((val) => {
                  return (
                    <li>
                      <Link
                        color="inherit"
                        onClick={navigateTo(val.generatedPath)}
                        className={css.colorWhite}
                        href={val.generatedPath}
                      >
                        {val.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className={css.linkBox}>
              <h3>
                <FormattedMessage id="footer_customerService" defaultMessage="Customer Service" />
              </h3>
              <ul>
                <li>
                  <Link
                    color="inherit"
                    onClick={navigateTo(`/${intl.locale}/contactUs`)}
                    className={css.colorWhite}
                    href={`/${intl.locale}/contactUs`}
                  >
                    <FormattedMessage id="footer_contactus" defaultMessage="Contact Us" />
                  </Link>
                </li>
                <li>
                  <Link
                    color="inherit"
                    onClick={navigateTo(`/${intl.locale}/faq`)}
                    className={css.colorWhite}
                    href={`/${intl.locale}/faq`}
                  >
                    <FormattedMessage id="footer_faqs" defaultMessage="FAQs" />
                  </Link>
                </li>
                {/* <li>
                  <FormattedMessage id="footer_covid" defaultMessage="COVID-19 Measures" />
                </li> */}
              </ul>
            </div>
            <div className={css.linkBox}>
              <h3>
                <FormattedMessage id="footer_myaccount" defaultMessage="My Account" />
              </h3>
              <ul>
                {!isLoggedIn ? (
                  <>
                    <li>
                      <Link
                        color="inherit"
                        onClick={navigateTo(`/${intl.locale}/login`)}
                        className={css.colorWhite}
                        href={`/${intl.locale}/login`}
                      >
                        <FormattedMessage id="footer_signIn" defaultMessage="Sign In" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        color="inherit"
                        onClick={navigateTo(`/${intl.locale}/login`)}
                        className={css.colorWhite}
                        href={`/${intl.locale}/login`}
                      >
                        <FormattedMessage
                          id="footer_createAccount"
                          defaultMessage="Create Your Account"
                        />
                      </Link>
                    </li>
                  </>
                ) : (
                  ''
                )}
                <li>
                  <Link
                    color="inherit"
                    onClick={navigateTo(`/${intl.locale}/${profileLink}`)}
                    className={css.colorWhite}
                    href={`/${intl.locale}/login`}
                  >
                    <FormattedMessage id="footer_myaccount" defaultMessage="My Account" />
                  </Link>
                </li>
              </ul>
            </div>
            <div className={css.linkBox}>
              <h3>
                <FormattedMessage id="footer_learnMore" defaultMessage="Learn More" />
              </h3>
              <ul>
                <li>
                  <Link
                    color="inherit"
                    onClick={navigateTo(`/${intl.locale}/privacyPolicy`)}
                    className={css.colorWhite}
                    href={`/${intl.locale}/privacyPolicy`}
                  >
                    <FormattedMessage
                      id="navigation_privacyPolicy"
                      defaultMessage="  Privacy Policy"
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    color="inherit"
                    onClick={navigateTo(`/${intl.locale}/terms`)}
                    className={css.colorWhite}
                    href={`/${intl.locale}/terms`}
                  >
                    <FormattedMessage
                      id="offers_termscondition"
                      defaultMessage="Terms and Conditions"
                    />
                  </Link>
                </li>
              </ul>
            </div>
            <div className={css.linkBox}>
              <h3>
                <FormattedMessage id="aboutus_heading" defaultMessage="ABOUT US" />
              </h3>
              <ul>
                <li>
                  <Link
                    color="inherit"
                    href={getLocalizeURL('storelocator')}
                    className={css.colorWhite}
                    onClick={navigateTo(getLocalizeURL('storelocator'))}
                  >
                    <FormattedMessage
                      id="navigation_storeLocator"
                      defaultMessage=" Store Locations"
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    color="inherit"
                    onClick={navigateTo(`/${intl.locale}/aboutUs`)}
                    className={css.colorWhite}
                    href={`/${intl.locale}/aboutUs`}
                  >
                    <FormattedMessage id="aboutus_heading" defaultMessage="About Us" />
                  </Link>
                </li>
              </ul>
            </div>

            <div className={css.linkBox}>
              <h3>
                {' '}
                <FormattedMessage id="footer_followus" defaultMessage="Follow Us" />
              </h3>
              <ul className={css.socialMedia}>
                <li>
                  <Link
                    color="inherit"
                    className={css.colorWhite}
                    href={getSocialMedia('facebook')}
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link
                    color="inherit"
                    className={css.colorWhite}
                    href={getSocialMedia('twitter')}
                    target="_blank"
                  >
                    <FaTwitter />
                  </Link>
                </li>
                <li>
                  <Link
                    color="inherit"
                    className={css.colorWhite}
                    href={getSocialMedia('instagram')}
                    target="_blank"
                  >
                    <FaInstagram />
                  </Link>
                </li>
              </ul>

              <ul className={css.downloadLink}>
                <li>
                  <Link
                    color="inherit"
                    className={css.colorWhite}
                    href="https://play.google.com/store/apps/details?id=com.pizzahutapp"
                    target="_blank"
                  >
                    <img src={downloadApple} alt="" />
                  </Link>
                </li>
                <li>
                  <Link
                    color="inherit"
                    className={css.colorWhite}
                    href="https://play.google.com/store/apps/details?id=com.pizzahutapp"
                    target="_blank"
                  >
                    <img src={downloadGoogle} alt="" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className={css.contentBox}>
            <div className={css.content}>
              <p>
                <FormattedMessage id="footer_message1" />
              </p>
              <p>
                <FormattedMessage id="footer_message2" />
              </p>
              <p>
                <FormattedMessage id="footer_message3" />
              </p>
            </div>
          </div>
        </footer>
      )}
    </React.Fragment>
  );
}
